import React from "react";
import { BsCheck2 } from "react-icons/bs";
import { Box, Flex } from "rebass";
import { MdClose } from "react-icons/md";
import Tooltip from "./Tooltip";
import useResponsive from "../../hooks/useResponsive";
const Chip = ({ dataId, dataType, text, remove, ...props }) => {
  const { breakpoint } = useResponsive();
  return (
    <Flex
      p="0 5px 0 0"
      bg="rgb(209, 209, 209)"
      height={["24px", "32px"]}
      style={{ borderRadius: "40px", fontSize: "10px" }}
      ml="4px"
      {...props}
    >
      <Flex
        data-id={dataId}
        data-type={dataType}
        sx={{
          gap: ["5px", "10px"],
        }}
        justifyContent="center"
        alignItems={"center"}
        height={"100%"}
      >
        <Flex
          sx={{
            borderTopLeftRadius: "40px",
            borderBottomLeftRadius: "40px",
            padding: ["1px 0 1px 4px", "1px 4px 1px 6px"],
            alignItems: "center",
          }}
          height={"100%"}
        >
          <BsCheck2 size={breakpoint(["10px", "12px"])} />
        </Flex>
        <Tooltip content={text}>
          <Box
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: ["100px", "140px"],
              fontSize: ["10px", "1.2em"],
              lineHeight: ["10px", "1.2em"],
            }}
          >
            {text}
          </Box>
        </Tooltip>
        <Box
          sx={{
            borderRadius: 999,
            padding: ["1px", "2px"],
            backgroundColor: "#585858",
            cursor: "pointer",
            color: "rgb(209, 209, 209)",
          }}
          onClick={remove}
        >
          <MdClose size={breakpoint(["10px", "12px"])} />
        </Box>
      </Flex>
    </Flex>
  );
};

export default Chip;
